/**
 * إعدادات خدمات التبرع: عقود الصيانة والنظافة والتعقيم.
 * توحيد تجربة المستفيد عبر تعريف المسارات والتسميات لكل خدمة.
 */
type DonationServiceConfig = {
  /** مسار إرسال الطلب (PATCH) */
  sendPath: string;
  /** معرف التبويب في طلباتي */
  tabId: "maintenance" | "hygiene";
  /** عنوان قسم الطلبات القائمة */
  requestsSectionTitle: string;
  /** اسم الخدمة (للعرض) */
  serviceLabel: string;
};

export const MAINTENANCE_CONFIG: DonationServiceConfig = {
  sendPath: "/api/donations/supply/request/send",
  tabId: "maintenance",
  requestsSectionTitle: "طلبات عقود الصيانة القائمة",
  serviceLabel: "عقود الصيانة",
};

export const HYGIENE_CONFIG: DonationServiceConfig = {
  sendPath: "/api/emasjid/patch/hygiene/supply/request/send",
  tabId: "hygiene",
  requestsSectionTitle: "طلبات أعمال النظافة والتعقيم القائمة",
  serviceLabel: "أعمال النظافة والتعقيم",
};
